import React from "react";
import { useTheme } from "styled-components";
import {
  InfoWrapper,
  Label,
  LabelArrow,
  Text,
  TimeWrapper,
  Title,
  TitleText,
  Wrapper,
} from "./style";
import Time from "../../timer/Time";
import { urlValidator } from "../../../../../helpers/validators";
import EditableText from "../../inline-edit/EditableText";
import EditableLine from "../../inline-edit/EditableLine";
import getReadableColor from "../../../../../components/ui/color-picker/getReadableColor";

const Arrow = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M2.8125 9L15.1875 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.125 14.0625L15.1875 9L10.125 3.9375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function SmallCountdown({ data, isEditable, viewMode = "view" }) {
  const {
    title,
    text,
    colorFields,
    timerLayout,
    time,
    url,
    newTab,
    borderRadius,
    linkText,
  } = data;

  const checkLayout = (prop) =>
    !!timerLayout.find((item) => item.value === prop);

  const theme = useTheme();

  const readableTextColor = getReadableColor(colorFields.Timer[theme.name]);

  return (
    <Wrapper
      borderRadius={borderRadius}
      onClick={() => {
        if (
          viewMode === "view" &&
          urlValidator({ url: url?.link, protocols: ["https:"] })
        )
          window.open(url?.link, newTab ? "_blank" : "_top");
      }}
    >
      <TimeWrapper bgClr={colorFields.Timer[theme.name]}>
        <Time time={time} color={readableTextColor} hasSeconds={false} />
      </TimeWrapper>
      <InfoWrapper>
        <TitleText>
          <Title hasText={checkLayout("text")}>
            <EditableText
              isEditable={isEditable}
              value={title}
              propKey="title"
              customCalculatorStyles={{ minHeight: "1em" }}
            />
          </Title>
          {checkLayout("text") && (
            <Text>
              <EditableText
                isEditable={isEditable}
                value={text}
                propKey="text"
                customCalculatorStyles={{ minHeight: "1em" }}
              />
            </Text>
          )}
        </TitleText>
        {(checkLayout("arrow") || checkLayout("label")) && (
          <LabelArrow>
            {checkLayout("label") && (
              <Label>
                <EditableLine
                  value={linkText}
                  propKey="linkText"
                  isEditable={isEditable}
                />
              </Label>
            )}
            {checkLayout("arrow") && <Arrow />}
          </LabelArrow>
        )}
      </InfoWrapper>
    </Wrapper>
  );
}

export default SmallCountdown;
